import React from 'react';
import { SelectValueLabel } from 'common/types/SelectValueLabel';
import { FiltersFormModel } from '../filters/FiltersView';
import FuelConsumptionPerAsset from './FuelConsumptionPerAsset';

type Props = { vehicles?: SelectValueLabel[]; lockedVehicleId?: string; filters?: FiltersFormModel };

const FuelConsumptionCombustionWidget = (props: Props) => (
	<FuelConsumptionPerAsset {...props} fuelKind="combustion" />
);

export default FuelConsumptionCombustionWidget;
